export const Labels = {
  MultipleChoice: 'Multiple Choice',
  Text: 'Text',
  Numeric: 'Numeric',
  Integer: 'Integer',
  MultiSelect: 'Multi Select',
  SingleSelect: 'Single Select',
  Question: 'Question',
  Options: 'Options',
  Type: 'Type',
  LongText: 'Long Text',
  ShortText: 'Short Text',
};

export const Mode = {
  CREATE: 'Create',
  EDIT: 'Edit',
  VIEW: 'view',
};

export const docutypeEnum = Object.freeze({
  PDF: '.pdf',
  DOC: '.doc',
  DOCX: '.docx',
});

export const shortTextLenght = 150;
export const longTextLenght = 1000;

export const MailOBJ = {
  title: 'Send E-mail',
  description: '',
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};

export const CallOBJ = {
  title: 'Call Candidate',
  description: '',
  bgImage: `${process.env.PUBLIC_URL}/assests/img/CallBackground.png`,
};

export const CallConnectedOBJ = {
  title: 'Call Candidate',
  description: '',
  bgImage: ``,
};

export const ContactCandidate = {
  title: 'Contact candidate',
  description: 'Choose one option to contact candidate',
  bgImage: ``,
};

export const smsOBJ = {
  title: 'Send SMS',
  description: '',
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};

export const WhatsAppOBJ = {
  title: 'WhatsApp Conversation',
  description: '',
  bgImage: ``,
};

export const safeJSONParse = (value, fallback = null) => {
  try {
    return typeof value === 'string' ? JSON.parse(value) : value;
  } catch {
    return fallback;
  }
};

export const PORTAL_SOURCES = [
  'Job Board Portal',
  'Cloud Sourcing',
  'Employee Portal',
  'Vendor Sourcing',
];

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;